import { useDispatch, useSelector } from 'react-redux'
import { goBack } from 'slices/drawer'
import { STATICS } from 'statics'
import './style.scss'

export function DrawerHeader({
  rightButtonIcon,
  onRightButtonClick,
  onClose,
  onLeftButtonClick,
  title = '',
  hideBackButton,
  color = false,
  hideCloseButton,
}) {
  const { history, allowCloseOnReturnButton } = useSelector(({ drawer }) => drawer)
  const dispatch = useDispatch()

  function hideReturnButton() {
    const hasHistory = history.length === 0

    return (!allowCloseOnReturnButton && hasHistory) || hideBackButton
  }

  function handleReturnClick() {
    dispatch(goBack())
  }

  function handleCloseButtonClick() {
    if (onClose) onClose()
  }

  function renderLeftButton() {
    if (hideReturnButton()) return null

    return (
      <button
        type='button'
        className={`icon -left ${color ? '-color' : ''}`}
        onClick={onLeftButtonClick || handleReturnClick}
        data-cy='button-back-drawer'
      >
        <STATICS.ARROW_BACK />
      </button>
    )
  }

  function renderRightButton() {
    if (hideCloseButton) return null

    return (
      <button
        type='button'
        className='icon -right'
        onClick={onRightButtonClick || handleCloseButtonClick}
        data-cy='button-close-drawer'
      >
        {rightButtonIcon || <STATICS.CLOSE />}
      </button>
    )
  }

  function renderDrawerTitle() {
    return <h2 className={`drawer-title ${color ? '-color' : ''}`}>{title}</h2>
  }

  return (
    <div className='drawer-header'>
      {renderLeftButton()}
      {renderDrawerTitle()}
      {renderRightButton()}
    </div>
  )
}
